module.exports = __webpack_public_path__ + "static/media/flyer.d9de303d.jpg";